import { useCallback, useEffect } from 'react';
import { create } from 'zustand';
import { usePersistItem } from '~/components/Store';

export type TabStore = {
  [key: string]: any;
};

export const useTabStore = create<TabStore>((set) => ({
  setValue: (name: string, value: any) =>
    set(() => ({
      [name]: value,
    })),
}));

export type UseTabOptions<T = any> = {
  name: string;
  initialValue?: T;
};

export const useTab = <T = any>({ name, initialValue }: UseTabOptions) => {
  const { value, setStoreValue } = useTabStore(({ [name]: value = initialValue, setValue }) => ({
    value: value as T,
    setStoreValue: setValue,
  }));

  const setValue = useCallback(
    (value?: T) => {
      setStoreValue(name, value);
    },
    [name, setStoreValue]
  );

  useEffect(() => {
    if (initialValue !== undefined) {
      setValue(initialValue);
    }
  }, [initialValue, setValue]);

  return {
    value,
    setValue,
  };
};

export const usePersistTab = <T = any>({ name, initialValue }: UseTabOptions) => {
  const { value = initialValue, setValue } = usePersistItem(name);
  return {
    value,
    setValue,
  };
};
